module.exports = "<hr />\n<h2>Coins owned by attendees</h2>\n<hr />\n\n<h3 id=\"TotalCoinsTitle\"></h3>\n<div class=\"chart_wrapper\">\n  <canvas id=\"TotalCoinsChart\" height=\"130\"></canvas>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/coins-owned-by-attendees/coins-owned-by-attendees.component.html
// module id = ./src/app/coins-owned-by-attendees/coins-owned-by-attendees.component.html
// module chunks = main